import { ValueOf } from "./generic"

export const NavigationOpenables = {
    cart: 'cart',
    postalCode: 'postalCode',
    deliveryReservation: 'deliveryReservation',
    deliveryReservationNoUser: 'deliveryReservationNoUser',
    searchDropdown: 'searchDropdown'
} as const

export type NavigationOpenables = ValueOf<typeof NavigationOpenables>